const roiSimulation = {
  pageName: 'ROI-Simulation',
  subtitle:
    'Vergleichen Sie einen operativen Basislauf mit einem von MoveAI optimierten Lauf und wandeln Sie die Differenzen in eine ROI-Geschichte um.',
  controls: {
    title: 'Läufe zum Vergleich auswählen',
    grid: 'Raster',
    table: 'Tabelle',
    filters: {
      baseline: {
        title: 'Basislauf',
        description: 'Ruft KPIs für das ausgewählte Datum anhand des aktuellen Workflows des Kunden ab.',
      },
      moveAI: {
        title: 'MoveAI-Lauf',
        description: 'Ruft KPIs für den optimierten Lauf ab, der von MoveAI für denselben Vorgang erstellt wurde.',
      },
      load: 'Laden',
      loaded: 'Geladen',
    },
  },
  barGraph: {
    title: 'Wichtige Differenzen (Basis vs. MoveAI)',
    kpisSelected: 'KPIs ausgewählt',
    selectKpis: 'KPIs zur Anzeige auswählen',
    selected: 'ausgewählt',
  },
  kpiComparisons: {
    title: 'KPI-Vergleiche',
    resetKpis: 'KPIs zurücksetzen',
    showDiffAs: 'Differenz anzeigen als:',
    absolute: 'Absolut',
    percentage: '%',
  },
  roiInputs: {
    title: 'ROI-Eingaben',
    reset: 'Zurücksetzen',
    perMonth: 'pro Monat',
    tabs: {
      laborSavings: 'Personalkosten-Einsparungen',
      supplierCosts: 'Lieferantenkosten',
      feesHorizon: 'Gebühren & Zeitraum',
    },
    labor: {
      dispatchersToday: 'Disponenten heute',
      dispatchersTodayTooltip: 'Anzahl der derzeit beschäftigten Disponenten.',
      dispatchersWithMoveAI: 'Disponenten mit MoveAI',
      dispatchersWithMoveAITooltip: 'Geschätzte benötigte Disponenten nach MoveAI.',
      costPerDispatcher: 'Kosten pro Disponent',
      hoursPerDay: 'Stunden pro Tag',
      workingDaysPerMonth: 'Arbeitstage pro Monat',
      currency: 'Währung',
      savingsTitle: 'Geschätzte Einsparungen bei Disponenten (monatlich)',
      savingsDescription: 'Basierend auf reduzierten Disponenten × Stundensatz × Stunden/Tag × Arbeitstage/Monat.',
    },
    supplier: {
      costsToday: 'Lieferantenkosten heute (monatlich)',
      costsWithMoveAI: 'Lieferantenkosten mit MoveAI (monatlich)',
      savingsTitle: 'Lieferanten-Einsparungen (monatlich)',
      savingsDescription: 'Basis-Lieferantenkosten abzüglich MoveAI-Lieferantenkosten.',
      totalSavingsTitle: 'Gesamte Einsparungen (monatlich)',
      totalSavingsDescription: 'Personal- + Lieferanten-Einsparungen.',
    },
    fees: {
      paymentPlan: 'Zahlungsplan',
      roiHorizon: 'ROI-Zeitraum',
      platformMonthlyFee: 'Monatliche Plattformgebühr',
      oneTimeImplementationFee: 'Einmalige Implementierungsgebühr',
      avgBookingsPerMonth: 'Durchschn. Buchungen pro Monat',
      platformBookingFee: 'Plattform-Buchungsgebühr',
      totalCostTitle: 'Gesamtkosten (Zeitraum)',
      totalCostDescription: 'Implementierung + (monatliche Gebühren × Zeitraum).',
      paybackTitle: 'Amortisationszeit',
      paybackDescription: 'Gesamtkosten / (monatliche Einsparungen - monatliche Gebühr).',
      roiTitle: 'ROI',
      roiDescription: 'Nettonutzen über den Zeitraum / Gesamtkosten.',
      monthlyFee: 'Monatliche Gebühr',
      perBookingFee: 'Gebühr pro Buchung',
    },
    executiveSummary: {
      title: 'Zusammenfassung',
      dispatcherSavings: 'Geschätzte Einsparungen bei Disponenten (monatlich)',
      supplierSavings: 'Lieferanten-Einsparungen (monatlich)',
      totalSavings: 'Gesamte Einsparungen (monatlich)',
      totalCost: 'Gesamtkosten (Zeitraum)',
      paybackTime: 'Amortisationszeit',
      roi: 'ROI',
    },
    suffix: {
      hrs: 'Std.',
      days: 'Tage',
      day: 'Tag',
      hr: '/Std.',
      months: 'Monate',
    },
  },
  roiCardsContainer: {
    kpis: {
      totalReservations: 'Buchungen gesamt',
      assignedReservations: 'Zugewiesene Buchungen',
      unassignedReservations: 'Nicht zugewiesene Buchungen',
      sharedRideReservations: 'Geteilte Buchungen',
      totalTrips: 'Fahrten gesamt',
      assignedTrips: 'Zugewiesene Fahrten',
      unassignedTrips: 'Nicht zugewiesene Fahrten',
      sharedRideTrips: 'Geteilte Fahrten',
      driversWithShifts: 'Fahrer mit Schichten',
      assignedDrivers: 'Zugewiesene Fahrer',
      avgTripsPerDriver: 'Durchschn. Fahrten / Fahrer',
      avarageBookingsPerDriver: 'Durchschn. Buchungen / Fahrer',
      averageTripsDistance: 'Durchschn. Fahrtstrecke',
      averageTripsDuration: 'Durchschn. Fahrtdauer',
      averageDeadheadDistance: 'Durchschn. Leerfahrt',
      averageIdleTime: 'Durchschn. Leerlaufzeit',
      totalEarnings: 'Gesamteinnahmen',
      earningPerHour: 'Einnahmen pro Stunde',
      averageTripsEarnings: 'Durchschn. Fahrteinnahmen',
      averageEarningsPerDriver: 'Durchschn. Einnahmen / Fahrer',
      totalCost: 'Gesamtkosten',
    },
    baseline: 'Basis',
    moveAI: 'MoveAI',
    noChange: 'Keine Änderung',
    disabled: 'Deaktiviert',
    kilometers: 'km',
    minutes: 'Min.',
    currency: '$',
    k: 'k',
    plus: '+',
    minus: '-',
    percentage: '%',
  },
  tableView: {
    kpiName: 'KPI-Name',
    diff: 'Diff.',
    exportTable: 'Tabelle exportieren',
    kpis: 'KPIs',
    exportedAt: 'Daten exportiert am: {{date}}',
  },
  filters: {
    suppliers: {
      title: 'Lieferant:',
      placeholder: 'Lieferant',
    },
    attributes: {
      title: 'Attribut:',
      placeholder: 'Attribut',
    },
  },
};

export default roiSimulation;
